// Roly používateľa — frontendový náprotivok backend/src/lib/roles.js.
// Držať v zhode; backend je autorita, toto je len UI (čo zobraziť a kam pustiť).

import { levelFromRole } from './levels';

export const SUBMITTER = 'submitter';

// Kto smie vidieť doklady. ALLOWLIST, rovnako ako na backende — pri pridaní
// ďalšej „slepej" roly sa tak nesprístupní modul omylom.
const DOCUMENT_READER_ROLES = ['super_admin', 'admin', 'accountant', 'viewer'];

export function canReadDocuments(user: any): boolean {
  if (!user) return false;
  if (user.isSuperAdmin) return true;
  if (levelFromRole(user.role) !== null) return true;
  return DOCUMENT_READER_ROLES.includes(user.role);
}

export function userRoleLabel(role?: string | null): string {
  const lvl = levelFromRole(role);
  if (lvl !== null) return `Schvaľovateľ (${lvl}. úroveň)`;
  return ({
    super_admin: 'Super admin',
    admin: 'Administrátor',
    accountant: 'Účtovník',
    submitter: 'Zberač dokladov',
    viewer: 'Pozorovateľ',
  } as Record<string, string>)[String(role || '')] || String(role || '');
}
